<template>
  <div id="home">
    <my-header ></my-header>
    <div class="pd20">
      <h3>User request removal</h3>
      
      <a v-if="!is_loggedin" class="pointer" @click="processLogin" >You need login by your phone to process removal request</a>
      <form v-on:submit.prevent="submitForm" v-else>
        <p>Your phone: {{ user.vn_phone }}</p>
        <p>Please tell us why do you need to delete your account and submit the form, we will review and process your request.</p>
        <label class="mt20">Notes</label>
        <textarea
          v-model="item.notes"
          ref="note"
          required
          class="form-control"
          rows="3"
        ></textarea>
        
        <button class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          Send
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import Utils from "@/helpers/utils";
import MyHeader from '@/components/Layout/Header';
//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "FormHarvest",
  components: {
    MyHeader,
  },
  data() {
    return {
      working: false,
      is_loggedin: false,
      user:null,
      item: {}
    };
  },
  created() {
    // clone from original params
  },
  mounted () {
    var localUser = this.$localStorage.get('user')
    this.is_loggedin = localUser != null
    if (localUser){
      this.user = JSON.parse(localUser)
      console.log('this.user', this.user)
    }
    
  },
  methods: {
    defaultValue() {
      return {
        notes: "",
      };
    },
    processLogin () {
      
      window.REQUIRE_LOGIN_ROUTE_NAME = 'DeleteUserRequest' // set callback after login
      this.$router.push({ name: 'Login' })
      
    },
    submitForm() {
      let data = JSON.parse(JSON.stringify(this.item));
      
      

      var request = Utils.requestV2(this, true).post(`/userRemoveRequest/`,data)
      this.working = true;
      request
        .then(response => {
          this.working = false;
          if (!response.data.id) {
            return Utils.showError(this, this.$t(response.data.data));
          } else {
            this.item = this.defaultValue()
            Utils.showSuccess(this, `Your request has been sent`)
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Page/DeleteUserRequest.vue